import { render, staticRenderFns } from "./ItemsMovementBulk.vue?vue&type=template&id=7f7d0045&scoped=true&"
import script from "./ItemsMovementBulk.vue?vue&type=script&lang=js&"
export * from "./ItemsMovementBulk.vue?vue&type=script&lang=js&"
import style0 from "./ItemsMovementBulk.vue?vue&type=style&index=0&id=7f7d0045&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7d0045",
  null
  
)

export default component.exports